import '@/app/app.css';
import './blog-article.css';

import '@/app/app';
import '@/layouts/main/main';
import { SwiperCarousel } from '@/shared/swiper/swiper-carousel/swiper-carousel';
import { Comment } from '@/widgets/section/section-comments/comment/comment';
import { vars } from '@/app/config/variables';

window.app.SwiperCarousel = SwiperCarousel;
window.app.Comment = Comment;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-swiper-carousel').forEach((element) => {
		new SwiperCarousel(element);
	});

	document.querySelectorAll('.js-blog-carousel').forEach((element) => {
		new SwiperCarousel(element, {
			[vars.breakpoint.tablet]: {
				slidesPerView: 3,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				spaceBetween: 8,
			},
			[vars.breakpoint.laptop]: {
				slidesPerView: 4,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				spaceBetween: 16,
			},
		});
	});

	document.querySelectorAll('.js-comment').forEach((element) => {
		new Comment(element);
	});
});
